<script setup>
import { ref } from "vue";
import { defineProps } from "vue";
const props = defineProps({
  title: { type: String, required: true },
  ariaTitle: { type: String, required: true },
});
console.log(props);
const showPanel = ref(false);
const togglePanel = () => {
  showPanel.value = !showPanel.value;
};
</script>

<template>
  <div
    class="bg-[#fff] panel mt-10 container border border-[#000] rounded-xl mb-4"
  >
    <button
      :arial-controls="'accordion-content-' + ariaTitle"
      :id="'accordion-control-' + ariaTitle"
      @click.prevent="togglePanel"
      class="p-2 px-6 w-full font-semibold flex flex-row items-center justify-between"
    >
      <span class="material-icons text-[#000]">
        {{ title }}
      </span>
      <svg
        v-if="showPanel"
        xmlns="http://www.w3.org/2000/svg"
        width="51"
        height="51"
        viewBox="0 0 51 51"
        fill="none"
      >
        <circle cx="25.3309" cy="25.3309" r="25.3309" fill="#FFF000" />
        <path
          d="M17.0742 22.2212L25.3308 30.4405L33.5874 22.2212"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="83"
        height="83"
        viewBox="0 0 83 83"
        fill="none"
      >
        <g filter="url(#filter0_d_0_940)">
          <circle cx="41.3309" cy="36.3309" r="25.3309" fill="white" />
        </g>
        <path
          d="M38.2212 44.5874L46.4405 36.3308L38.2212 28.0742"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <filter
            id="filter0_d_0_940"
            x="0"
            y="0"
            width="82.6617"
            height="82.6616"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="8" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0323264 0 0 0 0 0.0598209 0 0 0 0 0.204167 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_0_940"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_0_940"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </button>
    <div
      :aria-hidden="!showPanel"
      :id="'content-' + ariaTitle"
      class="p-4"
      v-if="showPanel"
    >
      <slot></slot>
    </div>
  </div>
</template>
